import React, { Component} from 'react';
import "./button-classic.less"

const Button = (props) => {
	return (
		<input type = "button" className = {`button-classic ${props.className}`} value = {props.value} onClick = {props.click} disabled={props.disabled} />
	);
};

export default Button;